import { render, staticRenderFns } from "./RelatedFieldList.vue?vue&type=template&id=6ef2e06a&scoped=true"
import script from "./RelatedFieldList.vue?vue&type=script&lang=js"
export * from "./RelatedFieldList.vue?vue&type=script&lang=js"
import style0 from "./RelatedFieldList.vue?vue&type=style&index=0&id=6ef2e06a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef2e06a",
  null
  
)

export default component.exports